import React from "react";
import { SpinnerWrapper, Turner } from "./LoadingWrapperStyles";
import { MainStore } from "../../stores/MainStore/MainStore";
import { useUnit } from "effector-react";

const LoadingWrapper: React.FC = () => {
  const { loading } = useUnit(MainStore);

  if (loading)
    return (
      <SpinnerWrapper>
        <Turner fontSize="large" />
      </SpinnerWrapper>
    );

  return <></>;
};

export default LoadingWrapper;
